// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// Element UI 按需引入 - 只引入实际使用的组件
import { Dialog, Input, Button, Checkbox, Popover, Message } from 'element-ui';
import App from './App'
import i18n from './i18n'
import store from './store'; // 导入store
/* 路由 */
import router from './router'
import LazyLoad from 'vue-lazyload';
Vue.use(LazyLoad, {
  preLoad: 1.3,
  loading: '',
  attempt: 1
});
/* axios */
import axios from './api'
import api from './api/api'

Vue.prototype.http = axios;
Vue.prototype.api = api;

/* swiper */
import 'swiper/dist/css/swiper.min.css';


/* jquery */
// import 'jquery'

/* bootstarp */
// import './assets/css/bootstrap.min.css'
// import './assets/js/bootstrap.min'
/* 重置样式 */
import './assets/css/reset.min.css'
/* animate.css */
import 'animate.css'

 
/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)



/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    const { titleKey } = to.meta || {};
    if (titleKey && i18n && i18n.t) {
      document.title = i18n.t(titleKey);
    }
    next();
});
// 注册Element UI组件
Vue.use(Dialog);
Vue.use(Input);
Vue.use(Button);
Vue.use(Checkbox);
Vue.use(Popover);

// 注册Message组件到Vue原型上
Vue.prototype.$message = Message;

// 初始化与 Vuex 语言同步
try {
  const current = store.getters.getLanguage || 'en';
  if (i18n.locale !== current) {
    i18n.locale = current;
  }
  store.subscribe((mutation, state) => {
    if (mutation.type === 'setLanguage') {
      i18n.locale = state.language || 'en';
    }
  });
} catch (e) {}

new Vue({
  el: '#app',
  router,
  store, // 注册store
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js